import { render, staticRenderFns } from "./VerificationOtp.vue?vue&type=template&id=641726ec&scoped=true&"
import script from "./VerificationOtp.vue?vue&type=script&lang=js&"
export * from "./VerificationOtp.vue?vue&type=script&lang=js&"
import style0 from "./VerificationOtp.vue?vue&type=style&index=0&id=641726ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641726ec",
  null
  
)

export default component.exports